import React, { ReactElement, ReactNode } from "react";
import { Modal } from "@src/components/elements/Modal";

interface Props {
  title: ReactElement | string;
  onClose: () => void;
  padding?: string;
  children?: ReactNode;
  minWidth?: string;
  maxWidth?: string;
  backgroundColor?: string;
  className?: string;
}

export const FloatingSidebar: React.FC<Props> = ({
  title,
  onClose,
  children,
  padding,
  minWidth,
  maxWidth,
  backgroundColor,
  className,
}) => {
  return (
    <Modal
      className={className}
      onClose={onClose}
      title={title}
      position="right"
      minWidth={minWidth ?? "40rem"}
      maxWidth={maxWidth ?? "75vw"}
      maxHeight="100vh"
      height="100vh"
      padding={padding}
      slideFromDirection="right"
      backgroundColor={backgroundColor}
    >
      {children}
    </Modal>
  );
};
